import React from "react";
import { Container, Row, Col } from "reactstrap";
import Mytable from "./Table";

const internetPlan = [
  { info1: "50 Mbps 300 Gb Unlimited 8mbps ", info2: "600/-" },
  { info1: "100 Mbps 400 Gb Unlimited 10mbps", info2: "800/-" },
  { info1: "100 Mbps 500 Gb Unlimited 12mbps", info2: "1000/-" },
  { info1: "100 Mbps 800 Gb Unlimited 15mbps", info2: "1400/-" },
  { info1: "100 Mbps 1200 Gb Unlimited 25mbps", info2: "2000/-" }
];

const voiceCallingPlan = [
  {
    info1: "50Mbps 500Gb Unlimited 2mbps with Calling Free from BSNL",
    info2: "777 /-"
  },
  {
    info1: "100Mbps 500Gb Unlimited 2mbps with Calling Free from BSNL",
    info2: "1277/-"
  }
];

export default class ThirdPage extends React.Component {
  render() {
    return (
      <div className="header-overlay2 bw-img">
        <Container>
          <Row>
            <Col>
              <div className="text-center">
                <span className="brand-name">Tariff Plans</span>
              </div>
            </Col>
          </Row>
          <br />
          <br />
          <Row>
            <Col>
              <Mytable caption="Internet Plans" data={internetPlan} />
            </Col>

            <Col>
              <Mytable caption="Voice Calling Plan" data={voiceCallingPlan} />
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}
